module.exports = __webpack_public_path__ + "static/media/illustrations-car-spinner-24.0bf70ea8.gif";